/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{s as r}from"../../../../chunks/vec42.js";import{ZEROS as o,create as t}from"../../../../core/libs/gl-matrix-2/factories/vec4f64.js";function s(t){return null==t?o:4===t.length?t:r(c,t[0],t[1],t[2],1)}const c=t();export{s as ensureColor4};
